import type React from "react";
import { useState } from "react";

const useUploadCSVEnrichmentFile = () => {
    const [file, setFile] = useState<null | File>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const csvFile = event?.target?.files?.[0];

        if (csvFile) {
            Object.defineProperty(csvFile, "name", {
                writable: true,
                value: csvFile.name.replace(".csv", ""),
            });

            setFile(csvFile);
        }
    };

    return {
        file,
        setFile,
        handleFileChange,
    };
};

export default useUploadCSVEnrichmentFile;
